import { render, staticRenderFns } from "./SpanishIbanInput.vue?vue&type=template&id=4fb534c0&scoped=true&"
import script from "./SpanishIbanInput.vue?vue&type=script&lang=js&"
export * from "./SpanishIbanInput.vue?vue&type=script&lang=js&"
import style0 from "./SpanishIbanInput.vue?vue&type=style&index=0&id=4fb534c0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fb534c0",
  null
  
)

export default component.exports